import httpClient from 'src/common/fetch/config'
import { GetOrgSnapshotQueryDTO, GetSnapshotQueryDTO } from './dto'
import { SnapshotModel } from './models'

// All four params are required by the backend contract. GET /snapshots reads them via @Query(),
export const getReportsSnapshot = (query: GetSnapshotQueryDTO): Promise<SnapshotModel[]> =>
  httpClient.get<SnapshotModel[]>('/snapshots', { params: query })

// Fetch all snapshots for the organization in one call (GET /snapshots/organization)
export const getOrgReportsSnapshot = (query: GetOrgSnapshotQueryDTO): Promise<SnapshotModel[]> =>
  httpClient.get<SnapshotModel[]>('/snapshots/organization', { params: query })
